
import React from 'react';
import { useIsMobile } from '@/hooks/use-mobile';

interface InstagramHeaderProps {
  inView: boolean;
  tokenExpired: boolean;
}

const InstagramHeader: React.FC<InstagramHeaderProps> = ({ inView, tokenExpired }) => {
  const isMobile = useIsMobile();
  
  return (
    <div 
      className={`text-center max-w-2xl mx-auto mb-8 ${
        inView ? 'opacity-100 translate-y-0 transition-all duration-700' : 'opacity-0 translate-y-10 transition-all duration-700'
      }`}
    >
      <h2 className={`section-title ${isMobile ? 'text-2xl' : ''}`}>Śledź Nas na Instagramie</h2>
      <p className={`section-subtitle ${isMobile ? 'text-xs' : ''}`}>
        Zobacz nasze najnowsze realizacje i kulisy sesji
      </p>
      
      {tokenExpired && (
        <div className="mt-2 text-xs text-red-600">
          <p className="mb-2">Uwaga: Wymagana jest aktualizacja tokenu Instagrama</p>
          <p className="text-gray-500 text-xs mb-3">
            Wyświetlamy przykładowe zdjęcia zamiast najnowszych postów z Instagrama
          </p>
        </div>
      )}
    </div>
  );
};

export default InstagramHeader;
